<template>
  <div id="app" @mousemove="locate">
    <NavBar/>
    <div class="container" id="container" >

      <router-view />
      <div class="objet3d" >
        <model-obj src="/objet/human-head.obj" :backgroundAlpha='bgAlpha'  :rotation="rotation"></model-obj>
      </div>
    </div>
    <canvas id="nodes"></canvas>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from '@/views/NavBar.vue'
import NodesModules from '@/assets/js/nodes.js'
import DirectionArrows from '@/components/ArrowsDirection.vue'
import {ModelObj} from 'vue-3d-model'

export default {
  name: 'App',
  components: {
    NavBar,
    DirectionArrows,
    ModelObj

  },
  data(){
    return{
      rotation: {
        x:0,
        y: -300,
        z: 0,
      },
      bgAlpha:0,
    }

  },
  created() {

    NodesModules.NodesJs({

      // container ID
      id: 'nodes',

      // width
      width: window.innerWidth,

      // height
      height: window.innerHeight,

      // background transition options
      backgroundFrom: [25, 55, 100],
      backgroundTo: [25, 55, 100],
      backgroundDuration: 4000,

      // the number of particles
      number: window.hasOwnProperty('orientation') ? 30 : 100,

      // animation speed
      speed: 20

    });
  },
  methods: {
    locate(event) {
      let posX = event.x;
      let midX = posX / 2;
      let posY = event.y;

      let midY = posY / 2;

      this.rotation.x = (event.y/ event.screenY ) - (midX / (event.screenX) )
      this.rotation.y = event.x/500
      // this.rotation.y =event.clientY
    }
  }

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

canvas {
  width: 100%;
  height: 100vh;
  position: absolute;
  z-index: -1;
  left: 0;
  top: 0;
}

.container {
  display: flex;
  height: calc(100vh - 90px);
  width: 100%;
  align-items: center;
  justify-content: space-evenly;
}

.objet3d {

  order: 2;
  transition: 3s;
  position: relative;
  width: 30%;
  height: 50%;
  background: transparent;
  z-index: 1;
}

.objet3d > * {
  background: transparent !important;
}

.home + .objet3d {
  transition: 3s;
  position: absolute;
}
</style>
